const cookiePrefix = 'finesio_';

export const BANNERS_STATE_COOKIE_NAME = `${cookiePrefix}banners_state`;
export const CATEGORY_THREE_OPEN_COOKIE_NAME = `${cookiePrefix}category_three`;

export const COOKIE_ACCESS_TOKEN = `${cookiePrefix}access_token`;
export const COOKIE_REFRESH_TOKEN = `${cookiePrefix}refresh_token`;
